import { styled } from "styled-components";

import MinusSVG from "../assets/minus-icon.svg?react";

export const StyledMinusIcon = styled(MinusSVG)`
  width: 24px;
  height: 24px;
`;
